import { z } from 'zod';

export const UpdateProfileSchema = z.object({
  /** 空文字列を許容 */
  iconDataUrl: z.string(),
});
